interface ISwitchPayTypeRouteProps {
  payType: string;
  route: any;
}
export const switchPayTypeRoute = ({
  payType,
  route,
}: ISwitchPayTypeRouteProps) => {
  if (payType !== "") {
    switch (payType) {
      case "trial":
        route.goSiteTrial();
        break;
      case "promotion":
        route.goSitePromotion({});
        break;
      case "basic":
        route.goPay({ type: "basic" });
        break;
      case "basicPlus":
        route.goPay({ type: "basicPlus" });
        break;
      case "plus":
        route.goPay({ type: "plus" });
        break;
      case "plusPlus":
        route.goPay({ type: "plusPlus" });
        break;
    }
  }
};
